module.exports = __webpack_public_path__ + "img/youmu konpaku mysterious sword master.2cf82356.png";